"use client";
// Staff-only screens (user_type A or S); other signed-in users go to /dashboard.
import { useAuth } from "context/UseContext";
import { Navigate } from "lib/router";

export default function Layout({ children }) {
  const { user } = useAuth();
  if (user?.user_type !== "A" && user?.user_type !== "S") return <Navigate to="/dashboard" />;
  return children;
}
